<template>
    <div class="main-content">
        <div class="uk-padding" v-if="project">
            <ul class="uk-breadcrumb">
                <li><router-link to="/projects">Projecten</router-link></li>
                <li><router-link :to="{ name: 'ProjectEdit', params: { id: $route.params.id }}">{{project.name}}</router-link></li>
            </ul>
            <h1>Project: {{project.name}}</h1>
            <div>
                <form>
                    <fieldset class="uk-fieldset">
                        <div class="uk-margin">
                            <input class="uk-input" v-model="project.name" type="text" placeholder="Projectnaam">
                        </div>
                        <div class="uk-margin">
                            <textarea class="uk-input" v-model="project.info" placeholder="Project Info"></textarea>
                        </div>
                        <div class="uk-margin">
                            <select class="uk-select" v-model="project.category">
                                <option v-for="c in categories">{{c}}</option>
                            </select>
                        </div>
                        <image-picker class="uk-margin" @choose="choose"></image-picker>
                         <div class="uk-child-width-1-4@m" uk-grid>
                            <div v-for="(g, i) in project.gallery" >
                                <div class="uk-card uk-card-default">
                                    <div class="uk-card-media-top">
                                        <img :src="g.small || g.url" alt="">
                                    </div>
                                    <div>
                                        <p>{{g.description}}</p>
                                    </div>
                                    <span class="uk-card-badge uk-label uk-label-danger" @click.prevent="removeImage(i)"><span uk-icon="trash"></span></span>
                                </div>
                            </div>
                        </div>
                        <button class="uk-button uk-button-primary uk-align-right" type="submit" @click.prevent="update"><span v-if="!loading">Updaten</span><span v-if="loading" uk-spinner></span></button>
                    </fieldset>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
var moment = require('moment');
import {db} from '@/CUSTOM/helpers/firebase'
import imageUploader from '@/CORE/modules/MEDIA/ImageUploader'
import imagePicker from '@/CORE/modules/MEDIA/imagePicker'
import Vue from 'vue'
export default {
    name: 'Projects',
    components: {imageUploader, imagePicker},
    data () {
        return {
            categories: null,
            project: {
                name: null,
                titel: null,
                info: null,
                link: {
                    url: null,
                    text: null,
                },
                color: null,
                categories: {},
                gallery: []
            },
            newCategory: null,
            loading: false
        }
    },
    created () {
        
        db.collection('categories').doc('all').get().then(doc => {
            this.categories = doc.data()
        }).catch(error => {
            console.log(error)
        })
    },
    mounted(){
        db.collection('projects').doc(this.$route.params.id).onSnapshot((snap) => {
            this.project = snap.data()
            this.$refs.editor.setContent(this.project.info);
        })
    },
    methods: {
        update () {
            this.loading = true
            this.project.lastEdit = Math.floor(Date.now() / 1000)
            db.collection('projects').doc(this.$route.params.id).update(this.project).then(r => {
                this.$store.dispatch('PUSH_NOTIFICATION', {message: 'Project aangepast', status: 'success'})
                this.$router.push('/projects')
            })
        },
        cancel () {
            this.newProject = {
                name: null
            }
        },
        convertDate (timestamp) {
            return moment.unix(timestamp).fromNow();
        },
        uploaded (files) {
            files.forEach(f => {
                this.project.gallery.push({text: null, file: f, cover: false})
            })
        },
        removeImage(i) {
            this.project.gallery.splice(i, 1);
        },
        addCategory () {
            this.project.categories.push(this.categories[this.newCategory])
        },
        removeCategory(key) {
            this.project.categories.splice(key, 1)
        },
        choose (images) {
            for(var i in images) {
                var img = images[i]
                this.project.gallery.push({key: i, description: img.description, url: img.url, medium: img.medium, large: img.large, extralarge: img.extralarge, small: img.small, cover: false, placeholder: img.placeholder, alt: img.alt, title: img.title})
            }
        }
    }
}
</script>
<style>
.vueditor {
    min-height: 300px;
}
</style>


// WEBPACK FOOTER //
// ProjectEdit.vue?6580776b